import { FirstStepFormData } from "../../../schemas/validationSchemas";
import { PoolInfo } from "../../../context/types";

export function transformFormDataToPoolInfo(
  formData: FirstStepFormData
): PoolInfo {
  return {
    shape: formData.shape!,
    depth: formData.depth,
    type: null,
    country: formData.country,
    state: formData.state,
    city: formData.city,
    postcode: formData.postcode,
    location: formData.location!,
    lowTemp: 0,
    electricityCost: formData.electricityCost,
    withCover: formData.withCover === "Yes",
    operatingHours: formData.operatingHours,
    requirePoolTemp: formData.requirePoolTemp,
    poolType: null,
    poolMaterial: formData.poolMaterial!,
    diameter: formData.diameter || 0,
    length: formData.length || 0,
    width: formData.width || 0,
    surfaceArea: formData.surfaceArea || 0,
  };
}
